import { render, staticRenderFns } from "./FollowUpStepWarningNotification.vue?vue&type=template&id=40e29246&scoped=true&"
import script from "./FollowUpStepWarningNotification.vue?vue&type=script&lang=js&"
export * from "./FollowUpStepWarningNotification.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpStepWarningNotification.vue?vue&type=style&index=0&id=40e29246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e29246",
  null
  
)

export default component.exports